@if (!hideTitle) {
    <div class="grid-title grid-market-pills" (click)="headerClick()">
        <ng-template *ngTemplateOutlet="iconTemplate || pillHeader" />
    </div>
}

<ng-template #pillHeader>
    <vn-icon class="sport-icon" size="16" [name]="iconClass" />
    <span class="sport-name">{{ gridHeaderOverride ?? sport.name }}</span>
</ng-template>

<div class="grid-group-container grid-market-pills selector">
    @if (sorting !== undefined) {
        <ms-sort-selector
            class="grid-pill-sort-selector sort-selector-web"
            [sorting]="sorting"
            [sortingTracking]="sortingTracking"
            (sortingChange)="sortingChanged($event)" />
    }

    @if (pills.length) {
        <ms-scroll-adapter [msScrollSelectedInView]="active?.id">
            <div class="grid-pills" [class.grid-pills-sort-enabled]="sorting !== undefined">
                @for (item of pills; track item.id) {
                    <button ds-pill size="small" [attr.data-menu-item-id]="item.id" [selected]="!!item.active" (click)="pillSelected(item)">
                        {{ item.title }}
                    </button>
                }
            </div>
        </ms-scroll-adapter>
    }
</div>

@if (showOnboardingTooltip) {
    @defer {
        <ms-inline-tooltip
            applyClass="grid-pills-tooltip-msg"
            tooltipPlacement="bottom-start"
            [hideOnScroll]="false"
            [showOnLoad]="true"
            [appendContent]="true">
            <div #tooltipContent class="tooltip-content">
                {{ sitecore.eventGrid.MarketPillOnboardingMessage }}
                <vn-icon class="grid-tooltip-close" name="theme-ex" size="12" (click)="closeTooltip()" />
            </div>
        </ms-inline-tooltip>
    }
}
